(() => {
  const pageType = document.currentScript?.dataset?.pageType || '';
  const normalize = (value) => (value || '').replace(/\s+/g, ' ').trim().toUpperCase();

  const makePromo = (href, image, eyebrow, title) => {
    const card = document.createElement('a');
    card.className = 'gs-clothing-promo-card';
    card.href = href;
    const img = document.createElement('img');
    img.src = image;
    img.alt = title;
    img.loading = 'lazy';
    const copy = document.createElement('span');
    copy.className = 'gs-clothing-promo-copy';
    copy.innerHTML = `<span class="gs-clothing-promo-eyebrow">${eyebrow}</span><span class="gs-clothing-promo-title">${title}</span>`;
    card.append(img, copy);
    return card;
  };

  const buildPromos = (className) => {
    const wrap = document.createElement('div');
    wrap.className = className;
    wrap.append(
      makePromo('/collections/neuheiten', 'https://cdn.shopify.com/s/files/1/0794/1567/3110/files/P1092892.png', 'Frisch eingetroffen', 'Neuheiten'),
      makePromo('/collections/schuhe', 'https://cdn.shopify.com/s/files/1/0794/1567/3110/files/7220A6C6-D3E1-423C-8230-26C50BE206B9.jpg', 'Für jeden Schritt', 'Schuhe entdecken')
    );
    return wrap;
  };

  const buildDesktopClothingMega = () => {
    const summary = Array.from(document.querySelectorAll('.header__primary-nav summary[data-title]')).find((node) => normalize(node.dataset.title) === 'KLEIDUNG');
    if (!summary) return;
    const details = summary.closest('details.header__menu-disclosure');
    if (!details || details.querySelector(':scope > .gs-clothing-mega-panel')) return;
    const originalList = details.querySelector(':scope > ul.header__dropdown-menu');
    if (!originalList) return;
    const sourceItems = Array.from(originalList.children);
    if (sourceItems.length !== 4) return;

    const panel = document.createElement('div');
    panel.className = 'gs-clothing-mega-panel';
    const columns = document.createElement('div');
    columns.className = 'gs-clothing-columns';

    sourceItems.forEach((item) => {
      const nestedDetails = item.querySelector('details.header__menu-disclosure');
      const groupSummary = nestedDetails?.querySelector(':scope > summary');
      const nestedList = nestedDetails?.querySelector(':scope > ul.header__dropdown-menu');
      if (!groupSummary || !nestedList) return;
      const column = document.createElement('div');
      column.className = 'gs-clothing-column';
      const heading = document.createElement('a');
      heading.className = 'gs-clothing-column-title';
      heading.href = groupSummary.dataset.followLink || '/collections';
      heading.textContent = groupSummary.textContent.replace(/\s+/g, ' ').trim();
      const links = document.createElement('div');
      links.className = 'gs-clothing-column-links';
      nestedList.querySelectorAll(':scope > li > a').forEach((sourceLink) => {
        const link = document.createElement('a');
        link.href = sourceLink.href;
        link.textContent = sourceLink.textContent.trim();
        links.appendChild(link);
      });
      column.append(heading, links);
      columns.appendChild(column);
    });

    if (columns.children.length !== 4) return;
    panel.append(columns, buildPromos('gs-clothing-promos'));
    details.appendChild(panel);
    originalList.classList.add('gs-clothing-original-hidden');
  };

  const buildMobileClothingPromos = () => {
    const sidebar = document.getElementById('sidebar-menu');
    if (!sidebar) return;
    const trigger = Array.from(sidebar.querySelectorAll('.header-sidebar__main-panel button[aria-controls]')).find((node) => normalize(node.textContent) === 'KLEIDUNG');
    if (!trigger) return;
    const panelId = trigger.getAttribute('aria-controls');
    const panel = panelId && sidebar.querySelector(`#${CSS.escape(panelId)}`);
    if (!panel || panel.querySelector('.gs-clothing-mobile-promos')) return;
    const list = panel.querySelector(':scope > ul.header-sidebar__linklist');
    if (list) list.insertAdjacentElement('afterend', buildPromos('gs-clothing-mobile-promos'));
  };

  const replaceExactText = (root, replacements) => {
    if (!root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      const key = node.nodeValue.replace(/\s+/g, ' ').trim();
      if (replacements[key]) node.nodeValue = node.nodeValue.replace(key, replacements[key]);
    });
  };

  const setAccordionCopy = (accordion, titleText, html) => {
    const summary = accordion.querySelector('summary');
    const title = summary?.querySelector('.accordion__toggle > span:first-child:not(.animated-plus)');
    if (title) title.textContent = titleText;
    const plus = summary?.querySelector('.animated-plus');
    if (plus) plus.textContent = '';
    const content = accordion.querySelector('.accordion__content');
    if (content) content.innerHTML = html;
  };

  const polishProductCopy = () => {
    if (pageType !== 'product') return;
    const faq = document.querySelector('.st_faq-section');
    if (faq) {
      const title = faq.querySelector('.st_faq-title');
      if (title) title.innerHTML = 'Noch Fragen? <span class="st_highlight">Wir helfen dir.</span>';
      faq.querySelectorAll('.st_faq-social-proof').forEach((node) => node.remove());
      const entries = [
        ['Dein Lieblingsstück ist ausverkauft?', '<p>Kein Stress: Öffne den Artikel, wähle deine gewünschte Größe und aktiviere die Benachrichtigung. Sobald dein Goldstück wieder verfügbar ist, erfährst du es direkt.</p>'],
        ['Bestellt – und jetzt doch noch etwas ändern?', '<p>Solange dein Paket noch nicht versendet wurde, versuchen wir gerne, deine Bestellung anzupassen. Melde dich dafür am besten so schnell wie möglich bei uns.</p>'],
        ['Wo finde ich die Teile aus Story oder Livestream?', '<p>Unsere neuen Teile gehen laufend online. Wenn du dein Lieblingsstück aus der Story oder dem Live noch nicht findest, schau einfach etwas später noch einmal bei den Neuheiten vorbei.</p>'],
        ['Passt doch nicht – wie funktioniert die Rückgabe?', '<p>Rückgabefähige Artikel kannst du innerhalb von 14 Tagen an uns zurücksenden:</p><p><strong>Goldstück Schwabach</strong><br>Rathausgasse 4<br>91126 Schwabach</p><p><strong>Bitte beachten:</strong> Schmuck, gewaschene Ware und Sale-Artikel sind von der Rückgabe ausgeschlossen.</p>'],
        ['Wann ist mein Goldstück bei mir?', '<p>Wir versenden deine Bestellung in der Regel am nächsten Werktag. Meistens ist dein Paket innerhalb von 3–4 Tagen bei dir.</p>']
      ];
      faq.querySelectorAll('.st_faq-item').forEach((item, index) => {
        const entry = entries[index];
        if (!entry) return;
        const question = item.querySelector('.st_faq-question');
        const icon = question?.querySelector('.st_faq-icon');
        if (question) {
          question.childNodes.forEach((node) => { if (node.nodeType === Node.TEXT_NODE) node.nodeValue = ''; });
          question.insertBefore(document.createTextNode(entry[0] + ' '), icon || null);
        }
        const answer = item.querySelector('.st_faq-answer-inner');
        if (answer) answer.innerHTML = entry[1];
      });
    }

    replaceExactText(document.querySelector('.shopify-section--main-product'), {
      'Schneller Versand': 'Schnell auf dem Weg',
      'Ratenzahlung': 'Flexibel bezahlen',
      'Premium Qualität': 'Mit Liebe ausgewählt',
      'Kundensupport': 'Persönlich für dich da',
      'Reduzierte Ware ist vom Umtausch ausgeschlossen!': 'Sale-Liebling gefunden? Bitte beachte: Reduzierte Artikel sind vom Umtausch ausgeschlossen.'
    });

    document.querySelectorAll('accordion-disclosure.accordion').forEach((accordion) => {
      const label = (accordion.querySelector('summary')?.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (label.includes('hinweis zur lieferzeit')) {
        setAccordionCopy(accordion, 'Dein Goldstück Studio Artikel braucht etwas länger', '<p>Dein Goldstück Studio Artikel wird für dich bedruckt bzw. personalisiert. Deshalb kann der Versand 4–15 Tage dauern. Danke für deine Geduld – dein besonderes Goldstück ist es wert. ♡</p>');
      }
      if (label.includes('hinweis zu schmuck')) {
        setAccordionCopy(accordion, 'Wichtig bei Schmuck & Sale', '<p>Aus hygienischen Gründen sind Schmuck und Socken von Rückgabe und Rückerstattung ausgeschlossen. Reduzierte Sale-Artikel sind vom Umtausch ausgeschlossen.</p>');
      }
    });
  };

  let scheduled = false;
  const initHeader = () => { scheduled = false; buildDesktopClothingMega(); buildMobileClothingPromos(); };
  const scheduleHeader = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(initHeader); } };
  const init = () => { scheduleHeader(); polishProductCopy(); setTimeout(polishProductCopy, 250); };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  const header = document.querySelector('.shopify-section--header') || document.querySelector('header');
  if (header) new MutationObserver(scheduleHeader).observe(header, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', () => setTimeout(() => { scheduleHeader(); polishProductCopy(); }, 100));
})();
